import { useState } from 'react';
import { GoogleAuthProvider, signInWithPopup, signOut } from 'firebase/auth';
import { auth } from '../config/firebase';
import { useNavigate } from 'react-router-dom';
import { SUPERADMIN_EMAILS } from '../context/AuthContext';

export default function Login() {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleGoogleLogin = async () => {
    setError('');
    setLoading(true);
    try {
      const provider = new GoogleAuthProvider();
      // Solo un hint de UI para Google (preselecciona/filtra cuentas del dominio): no es una
      // barrera de seguridad real, por eso se verifica el email exacto después de entrar.
      provider.setCustomParameters({ hd: 'undermix.cl' });
      const result = await signInWithPopup(auth, provider);
      const email = result.user.email?.toLowerCase() || '';

      if (!SUPERADMIN_EMAILS.includes(email)) {
        await signOut(auth);
        setError(`Acceso denegado. La cuenta ${email} no está autorizada como SuperAdmin.`);
        return;
      }

      navigate('/');
    } catch (err: any) {
      setError(err.message || 'Error al iniciar sesión con Google');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="max-w-md w-full bg-white rounded-3xl shadow-xl p-8 border border-gray-200 dark:border-gray-800">
        <div className="text-center mb-8">
          <img src="/logo.png" alt="Logo" className="w-16 h-16 object-contain rounded-2xl mx-auto mb-4 shadow-lg shadow-slate-900/10" />
          <h2 className="text-3xl font-extrabold text-gray-900 dark:text-white">CobrApp Web</h2>
          <p className="text-gray-500 dark:text-gray-400 mt-1 italic">SuperAdmin Dashboard</p>
        </div>

        {error && (
          <div className="mb-4 p-4 bg-red-50 border border-red-200 text-red-600 rounded-xl text-sm">
            {error}
          </div>
        )}

        <button
          type="button"
          onClick={handleGoogleLogin}
          disabled={loading}
          className="w-full flex items-center justify-center gap-3 bg-white border border-gray-300 dark:border-gray-700 text-gray-700 dark:text-gray-200 rounded-xl py-3 font-bold hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors disabled:opacity-70"
        >
          <svg width="20" height="20" viewBox="0 0 24 24">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          {loading ? 'Entrando...' : 'Iniciar sesión con Google'}
        </button>
        <p className="text-xs text-gray-400 text-center mt-4">Restringido a cuentas @undermix.cl autorizadas</p>
      </div>
    </div>
  );
}
